import { useState } from "react"

interface ProductListFilteringReturn {
  filterDrawerOpen: boolean
  setFilterDrawerOpen: (open: boolean) => void
}

export const useProductListFiltering = (): ProductListFilteringReturn => {
  const [filterDrawerOpen, setFilterDrawerOpen] = useState<boolean>(false)

  return {
    filterDrawerOpen,
    setFilterDrawerOpen,
  }
}
